import React from 'react'
import { Typography, Box } from '@mui/material'
import { useTranslation } from 'react-i18next'
import PaymentSelection from '../../../Elements/PaymentSelection'
import CreditCard from '../../../../Images/credit_92x61.svg'
import CreditCardSelected from '../../../../Images/credit-selected_92x61.svg'
import BankAccount from '../../../../Images/bank_76x72.svg'
import BankAccountSelected from '../../../../Images/bank-selected_76x72.svg'
import { PaymentMethodSelectionProps } from '../types'

const PaymentMethodSelection: React.FC<PaymentMethodSelectionProps> = ({
  isLicensing,
  isCardSelected,
  isBankSelected,
  achAllowed,
  achDisplayMessage,
  achDiscountAmount,
  onSelectCreditOrDebit,
  onSelectBankAccount,
}) => {
  const { t } = useTranslation()

  const additionalWarnings = [
    t(
      'PaymentModal.IsBankSelected.AdditionalWarning.Checking.Account',
      'Make sure the bank account you use is a "CHECKING" account'
    ),
    t(
      'PaymentModal.IsBankSelected.AdditionalWarning.Double.Check',
      'Please double-check your account number'
    ),
    t(
      'PaymentModal.IsBankSelected.AdditionalWarning.Time.Founds.Available',
      'NOTE that it may take up to 10 business days for funds to actually transfer'
    ),
  ]

  const CreditCardImage = () => (
    <img
      alt={t('PaymentModal.AltText.CardOption', 'Credit or Debit Card')}
      src={isCardSelected ? CreditCardSelected : CreditCard}
    />
  )

  const BankAccountImage = () => (
    <img
      alt={t('PaymentModal.AltText.BankOption', 'Bank Account Transfer')}
      src={isBankSelected ? BankAccountSelected : BankAccount}
    />
  )

  return (
    <>
      {!isLicensing && (
        <PaymentSelection
          header={t(
            'PaymentModal.Option.CreditOrDebit',
            'Credit or Debit Card'
          )}
          onClick={onSelectCreditOrDebit}
          isSelected={isCardSelected}
          image={CreditCardImage()}
        />
      )}
      {(achAllowed || isLicensing) && (
        <>
          <PaymentSelection
            header={t(
              'PaymentModal.Option.BankAccountTransfer',
              'Bank Account Transfer'
            )}
            subheader={
              achDisplayMessage && achDiscountAmount
                ? `${achDiscountAmount} ${t(
                    'PaymentModal.Option.BankAccountDiscount',
                    'Discount per paid program for bank account payments'
                  )}`
                : ''
            }
            onClick={onSelectBankAccount}
            isSelected={isBankSelected || isLicensing}
            image={BankAccountImage()}
          />
          {isBankSelected && (
            <Box sx={{ mt: 2, ml: 3 }}>
              {additionalWarnings.map((warning, index) => {
                return (
                  <Typography key={index} component="li" variant="subtitle2">
                    {warning}
                  </Typography>
                )
              })}
            </Box>
          )}
        </>
      )}
    </>
  )
}

export default PaymentMethodSelection
